<app-auth-page-layout>
  <app-signin-form class="flex flex-col flex-1"/>
</app-auth-page-layout>